export default __webpack_public_path__ + "static/media/remove-disabled.a6c24cff.svg";